import React, {useState} from 'react';
import {Button, Grid, ThemeProvider} from "@mui/material";
import {SETable} from "../../../../components/SETable";
import {RiAddFill, RiCheckboxCircleFill, RiErrorWarningFill, RiFilter3Line, RiFilterOffLine} from "react-icons/ri";
import {SEText} from "../../../../components/SEText";
import {SEButtonExport} from "../../../../components/SEButtonExport";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import {removeEmpty, removeEmptyProperties, sortByDirection} from "../../../../utils/utils";
import {formatDateToBR} from "../../../../../utils/time";
import useExcelExport from "../../../../hooks/useExcelExport";
import {useQuery} from "react-query";
import {tableColumns} from "./tableColumns";
import {ProjetoAcaoService} from "../services";
import {useHistory} from "react-router-dom";
import {ProjetoAcaoInterface} from "../../../../interfaces";
import useRenderFormStore from "../../stores/useRenderFormStore";
import useFormMutation from "../../hooks/useFormMutation";
import {BaSeDialogContext} from "@base/react";
import {handleModalAdmin} from "../../../../../utils/handleModalAdmin";
import {SEButton} from "../../../../components/SEButton";
import SEInputSearch from "../../../../components/SEInputSearch";
import theme from "../../../../mui-theme";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import moment from "moment/moment";

const Tabela = () => {

    const history = useHistory();

    const {setFormData, handleShowForm} = useRenderFormStore();

    const [searchText, setSearchText] = useState<any>(null);

    const {
        paginationFilters,
        bodyFilters,
        handleResetBodyFilters,
        handleChangeBodyFilter,
        handleLinesPerPage,
        handleChangeOrder,
        handlePageChange,
        handleSearchChange,
        setPaginationFilters
    } = useFilterHandler();

    const handleClickApplyFilter = async (inputValue: any, oqueVocePrecisa: boolean = false) => {
        setSearchText(inputValue);
        handleSearchChange(inputValue, oqueVocePrecisa)
    }

    const {showModal} = React.useContext(BaSeDialogContext);

    const handleCleanFilters = () => {
        handleResetBodyFilters()
        setSearchText(null)
    }

    const handleCreate = () => {
        const isCreating = history.location.pathname.includes('/create');
        if (!isCreating) {
            setFormData(null);
            handleShowForm(true);
            history.push(history.location.pathname + '/create')
        }
    }

    const {
        data,
        isLoading,
        refetch,
    } = useQuery({
        queryFn: () => ProjetoAcaoService.findAll(paginationFilters, bodyFilters),
        queryKey: ["projetoAcaoData", paginationFilters, bodyFilters],
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        refetchOnReconnect: true,
    });


    const {deleteMutation, updateStatusMutation} = useFormMutation({
        showModal,
        service: ProjetoAcaoService
    });

    const {
        data: dataPendants,
        refetch: refetchDataPendants,
    } = useQuery({
        queryFn: () => ProjetoAcaoService.getPendants(bodyFilters),
        queryKey: ["projetoAcaoPendentesData", paginationFilters, bodyFilters],
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });


    const handleDelete = async (id: any) => {
        handleModalAdmin({
            title: `Excluir Registro`,
            content: `Você tem certeza que deseja excluir esse registro?`,
            msgOnSuccess: `Registro excluído com sucesso`,
            onFinish: () => refetch(),
            onConfirmClick: () => deleteMutation(id),
            onCancelClick: () => console.log('modal closed...'),
            showModal: showModal,
            showAPIErrorIfAvailable: true
        });
    };

    const handleUpdateStatus = async (item: ProjetoAcaoInterface) => {
        const title = `${item.statusAprovacao === 'APROVADO' ? 'Desaprovar' : 'Aprovar'} esse registro`;
        const content = `Você tem certeza que deseja ${item.statusAprovacao === 'APROVADO' ? 'Desaprovar' : 'Aprovar'} esse registro?`;
        const msgOnSuccess = `O registro foi ${item.statusAprovacao === 'APROVADO' ? 'Desaprovado' : 'Aprovado'} com sucesso`;
        const msgOnError = `O registro não foi ${item.statusAprovacao === 'APROVADO' ? 'Desaprovado' : 'Aprovado'} Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`;
        const novoStatus = (item.statusAprovacao === 'PENDENTE' || item.statusAprovacao === 'REPROVADO' || item.statusAprovacao === null) ? 'APROVADO' : 'REPROVADO'

        const updateStatus = async (item: ProjetoAcaoInterface, status: any) => {
            const dataForm = {
                id: item.id,
            }
            await updateStatusMutation(removeEmpty(dataForm));
        };

        handleModalAdmin({
            title,
            content,
            msgOnSuccess,
            msgOnError,
            onFinish: () => {
                refetch()
                refetchDataPendants()
            },
            onConfirmClick: () => updateStatus(item, novoStatus),
            onCancelClick: () => console.log('modal closed...'),
            showModal: showModal,
        });
    };


    const handleEdit = (item: ProjetoAcaoInterface) => {
        console.log('item', item);
        const isEditing = history.location.pathname.endsWith('/edit');
        if (!isEditing) {
            setFormData(item);
            handleShowForm(true);
            history.push(`${history.location.pathname}/${item.id}/edit`)
        }
    }

    const fetchDataExcel = async () => {
        const bodyParams = removeEmptyProperties(bodyFilters);
        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};
        const response = await ProjetoAcaoService.findAll(pageFilter, bodyParams);
        return response?.content?.map((r: any) => ({
            DATA: r?.dataCriacao ? moment(r?.dataCriacao).format('DD/MM/YYYY') : '',
            CodigoPRATIF: r?.nuPratif,
            UF: r?.uf?.sigla,
            NOME: r?.nomePratif,
            ACAO: r?.acoes.map((ac: any) => ac?.nomeAcao),
            STATUS: r?.status,
        }));
    };

    const {executeDownload, downloading} = useExcelExport({
        handleDataCallback: fetchDataExcel,
        filename: `Exportacao_Projeto_Acao_${formatDateToBR(new Date())}`,
        colorLoading: '#3498db',
        isCsv: true,
    });

    const {data: filterOptions} = useQuery({
        queryFn: () => ProjetoAcaoService.getOptions(true),
        queryKey: [
            "editarAtendimentoOptionsTable",
            paginationFilters,
            bodyFilters,
        ],
    });

    const handleFilterByStatus = (status: string) => {
        if (status === bodyFilters?.status) {
            handleChangeBodyFilter('statusAprovacao', null)
            return;
        }
        handleChangeBodyFilter('statusAprovacao', status)
        setPaginationFilters({
            ...paginationFilters,
            page: 0,
        });
    };


    return (
        <Grid item>
            <Grid container>


                <Grid item xs={12}>
                    <Grid item>
                        <Grid item flexDirection="row" display="flex" alignItems="center">
                            <Grid
                                item
                                flexDirection="row"
                                display="flex"
                                alignItems="center"
                                mr={3}
                                mb={2}
                            >
                                <RiFilter3Line/>
                                <SEText as="p" size={"medium"} font="Mulish" weight="bold">
                                    Filtros
                                </SEText>
                            </Grid>
                        </Grid>
                        <ThemeProvider theme={theme}>
                            <Grid container spacing={2} my={2}>
                                <Grid item lg={4} md={4}>
                                    <SEFilterSelect
                                        defaultOption={"Todas"}
                                        id={"uf"}
                                        placeholder={"Selecione uma das opções"}
                                        label="UF"
                                        value={bodyFilters?.uf}
                                        options={sortByDirection(filterOptions?.ufs, 'sigla')}
                                        displayField="sigla"
                                        onChange={(value) => handleChangeBodyFilter("uf", value)}
                                    />
                                </Grid>

                                <Grid item lg={4} md={4}>
                                    <SEFilterSelect
                                        defaultOption={"Todos"}
                                        defaultOptionValue={""}
                                        placeholder={"Selecione uma das opções"}
                                        id={"nomePratif"}
                                        label="Nome do projeto"
                                        value={bodyFilters?.nomePratif}
                                        options={filterOptions?.nomePratif}
                                        onChange={(value) => handleChangeBodyFilter("nomePratif", value)}
                                    />
                                </Grid>

                                <Grid item lg={4} md={4}>
                                    <SEFilterSelect
                                        defaultOption={"Todas"}
                                        placeholder={"Selecione uma das opções"}
                                        id={"nomeAcao"}
                                        label="Nome da ação"
                                        displayField="nomeAcao"
                                        options={sortByDirection(filterOptions?.acoes, 'nomeAcao')}
                                        value={bodyFilters?.acoes?.length && bodyFilters?.acoes[0]}
                                        onChange={(value) => handleChangeBodyFilter("acoes", [value])}
                                    />
                                </Grid>
                            </Grid>
                        </ThemeProvider>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <SETable
                        pagination={true}
                        headerTableColor={"#7B80FF"}
                        tableColor={"#FFFFFF"}
                        totalElements={data?.totalElements}
                        totalPages={data?.totalPages}
                        linesPerPageFilters={paginationFilters?.linesPerPage}
                        isLoading={isLoading}
                        data={data?.content ?? []}
                        page={paginationFilters?.page}
                        columns={tableColumns({handleEdit, handleDelete, handleUpdateStatus})}
                        orderBy={paginationFilters?.orderBy}
                        direction={paginationFilters?.direction}
                        onOrderChange={handleChangeOrder}
                        onPagePreviousChange={handlePageChange}
                        onPageNextChange={handlePageChange}
                        onLinesPerPageChange={handleLinesPerPage}
                        tableHeader={
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" spacing={2} mb={2}>
                                    <Grid item md={3}>
                                        <SEInputSearch
                                            value={searchText}
                                            onClick={(inputValue) => handleClickApplyFilter(inputValue, false)}
                                        />
                                    </Grid>

                                    <Grid item>
                                        <Button
                                            style={{
                                                backgroundColor: "#7B80FF",
                                                fontFamily: "Mulish, sans-serif",
                                                fontSize: "12px",
                                            }}
                                            variant="contained"
                                            startIcon={<RiAddFill/>}
                                            onClick={() => handleCreate()}
                                        >
                                            Incluir
                                        </Button>
                                    </Grid>


                                    <Grid container item md={5} spacing={2} alignItems="center">
                                        <Grid item md={2}>
                                            <SEButton
                                                selected={bodyFilters?.statusAprovacao === "APROVADO"}
                                                onClick={() => handleFilterByStatus("APROVADO")}
                                            >
                                                <RiCheckboxCircleFill size={26} color="#66BD91"/> Aprovado
                                            </SEButton>
                                        </Grid>
                                        <Grid item md={10}>
                                            {!!dataPendants && (
                                                <SEButton
                                                    selected={bodyFilters?.statusAprovacao === "PENDENTE"}
                                                    onClick={() => handleFilterByStatus("PENDENTE")}
                                                >
                                                    <RiErrorWarningFill size={26} color="#F6E566" title={'Pendente'}/>
                                                    <SEText font={"Mulish"}>
                                                        {dataPendants === 1 ? " Existe " : " Existem "}
                                                        <b>{dataPendants} </b>
                                                        {dataPendants === 1 ? "item" : "itens"} aguardando aprovação
                                                    </SEText>
                                                </SEButton>
                                            )}
                                        </Grid>
                                    </Grid>

                                    <Grid item>
                                        <SEButtonExport isLoading={downloading} onClick={executeDownload}/>
                                    </Grid>
                                </Grid>

                                <Grid container justifyContent="space-between" alignItems="center" mb={2}
                                      sx={{padding: '7px'}}>
                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {!!data?.totalElements && (
                                                <SEText as="p" font="Mulish">
                                                    <strong>{data?.totalElements}</strong>{" "}
                                                    {data?.totalElements === 1
                                                        ? "resultado encontrado"
                                                        : "resultados encontrados"}
                                                </SEText>
                                            )}
                                        </div>
                                    </Grid>

                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            <SEButton onClick={handleCleanFilters}>
                                                <RiFilterOffLine size={20}/> Limpar Filtros
                                            </SEButton>
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tabela;